import IdentityCell from './IdentityCell';

export default IdentityCell;
